import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const vildChangesExportUrl = `${environment.apiUrl}/vildchanges/export`;
const vildChangesExportContractsUrl = contractIds =>
  `${environment.apiUrl}/vildchanges/export/contracts/${contractIds}`;

@Injectable()
export class VildChangesService {
  constructor(private readonly httpService: HttpService) {}

  downloadVildChanges(): Observable<any> {
    return this.httpService.post(vildChangesExportUrl, null);
  }

  downloadVildChangesContracts(contractIds: number[]): Observable<any> {
    return this.httpService.post(vildChangesExportContractsUrl(contractIds), null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/vild-changes.service.ts